var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-168 -246) translate(168 246.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "#1A171B"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(4 3.875)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M10.9 8.516c0 .849-.687 1.536-1.535 1.536-.847 0-1.535-.687-1.535-1.536 0-.848.688-1.534 1.535-1.534.848 0 1.534.686 1.534 1.534",
    transform: "translate(4 3.875) translate(1.333 1.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M2.925 5.604c-.283 0-.513-.23-.513-.515 0-.283.23-.513.513-.513h3.28c.284 0 .515.23.515.513 0 .284-.231.515-.514.515h-3.28zm0 2.186c-.283 0-.513-.23-.513-.514 0-.296.23-.526.513-.526h3.28c.284 0 .515.23.515.514 0 .296-.231.526-.514.526h-3.28zm0 2.187c-.283 0-.513-.23-.513-.515 0-.295.23-.526.513-.526h3.28c.284 0 .515.23.515.514 0 .296-.231.527-.514.527h-3.28zM1.805 1.23c-.304 0-.552.247-.552.551v9.889c0 .304.248.55.552.55h9.881c.304 0 .551-.246.551-.55V3.976c0-.304-.247-.551-.551-.551H8.98v.006H6.407c-.263 0-.521-.108-.708-.295L3.814 1.241l-2.01-.01zm0 12.018c-.872 0-1.58-.708-1.58-1.578V1.782c0-.87.708-1.58 1.58-1.58h2.013c.264 0 .522.108.708.295L6.41 2.393l2.57.01.033.006h2.673c.87 0 1.58.708 1.58 1.579v7.683c0 .87-.71 1.578-1.58 1.578H1.805z",
    transform: "translate(4 3.875) translate(1.333 1.333)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewCertificate);
export default __webpack_public_path__ + "static/media/icon_new_certificate.b99027dbd9e80dce098f88a84dd8f070.svg";
export { ForwardRef as ReactComponent };